import { render } from "./BigInputSearchComponent.vue?vue&type=template&id=3f0fd162&scoped=true"
import script from "./BigInputSearchComponent.vue?vue&type=script&lang=js"
export * from "./BigInputSearchComponent.vue?vue&type=script&lang=js"

import "./BigInputSearchComponent.vue?vue&type=style&index=0&id=3f0fd162&scoped=true&lang=css"

import exportComponent from "/Users/alejandrobernal/Documents/fbc/fbc-ecommerce-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0fd162"]])

export default __exports__